import { z } from 'zod';
import { createToolSignature } from './tool-signature';

export const getMyCompanyOfferingSummaryToolSignature = createToolSignature({
    name: 'getMyCompanyOfferingSummaryTool',
    description:
        "Get a description of the user's company, description of their customers, which markets they operate in and the products or services they provide",
    inputSchema: z.object({}),
    outputSchema: z.object({
        companySummary: z.string().describe('The summary of the company.'),
    }),
    toolCallUi: (input) => `Getting a summary of your company`,
});
